<div class="auth-page-wrapper auth-bg-cover py-5 d-flex justify-content-center align-items-center min-vh-100">
    <div class="bg-overlay"></div>
    <div class="auth-page-content overflow-hidden pt-lg-5">
      <div class="container">
        <div class="row">
          <div class="col-lg-12">
            <div class="card overflow-hidden">
              <div class="row g-0">
                <div class="col-lg-6">
                  <div class="p-lg-5 p-4 auth-one-bg h-100">
                    <div class="bg-overlay"></div>
                    <div class="position-relative h-100 d-flex flex-column">
                      <div class="mb-4">
                        <a routerLink="" class="d-block">
                          <img src="assets/images/weber-rescue-systems.png" alt="" height="45">
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-lg-6">
                  <div class="p-tb-5">
                    <div>
                      <h5 class="text-primary">{{ 'Forgot Password' | translate }}</h5>
                      <p class="text-muted">{{ 'Enter your email to reset your password' | translate }}</p>
                    </div>
                    <div class="mt-4">
                      <form [formGroup]="forgotPasswordForm" (ngSubmit)="onSubmit()">
                        <div class="mb-3">
                          <label class="form-label" for="email">{{ 'Enter your email' | translate }}</label>
                          <input type="email" id="email" class="form-control" formControlName="email" placeholder="{{'Enter your email' | translate}}">
                          <div *ngIf="submitted && forgotPasswordForm.controls.email.errors" class="text-danger">
                            <div *ngIf="forgotPasswordForm.controls.email.errors['required']">{{"Email is required" | translate}}</div>
                            <div *ngIf="forgotPasswordForm.controls.email.errors['email']">{{"Invalid email format" | translate}}</div>
                          </div>
                        </div>
                        <div class="mb-3">
                          <button type="submit" class="btn btn-primary w-100" [disabled]="submitted">{{ 'Send Reset Link' | translate }}</button>
                        </div>

                        <!-- Go to Login Page Button -->
                        <div class="mt-2">
                            <button class="btn btn-link w-100" type="button" (click)="goToLoginPage()">
                              {{ 'Back to Login' | translate }}
                            </button>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>